import React, { useRef, useEffect } from "react"; // Importe useRef e useEffect
import { HashLink } from "react-router-hash-link";
import NavBar from "../components/Navbar/NavBar";

const scrollWithOffset = (el) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  const yOffset = -110;
  window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
};

const Hero = ({ onHeightChange }) => {
  const heroRef = useRef(null);

  useEffect(() => {
    if (heroRef.current && onHeightChange) {
      const updateHeight = () => {
        const element = heroRef.current;
        const style = window.getComputedStyle(element);

        // 1. Altura total incluindo padding (offsetHeight)
        const totalHeight = element.offsetHeight;

        // 2. Obter o valor do padding inferior
        // O valor retornado é uma string (ex: "32px"), precisa ser parseado
        const paddingBottomString = style.paddingBottom;
        const paddingBottom = parseFloat(paddingBottomString) || 0;

        // 3. Altura sem o padding inferior
        const heightWithoutBottomPadding = totalHeight - paddingBottom;

        onHeightChange(heightWithoutBottomPadding);
      };

      updateHeight();
      window.addEventListener("resize", updateHeight);

      return () => {
        window.removeEventListener("resize", updateHeight);
      };
    }
  }, [onHeightChange]);

  return (
    <>
      <div className="hero" id="hero" ref={heroRef}>
        <div>
          <NavBar />
        </div>

        <div className="m-auto overflow-hidden mx-4 px-2 md:px-8 h-5/6">
          <div
            id="hero"
            className="flex flex-col md:flex-row py-8 mt-10 justify-between text-center md:text-left"
          >
            <div className="md:w-1/2 flex flex-col justify-center mt-12">
              <h1 className="mb-5 md:text-4xl text-3xl font-bold text-blue-900">
                Somos referência no mercado em fabricação de hélices
              </h1>
              <div className="text-xl font-semibold tracking-tight mb-5 text-gray-800">
                Para motores de popa e distribuição de produtos náuticos.
                <br />
                <br />
                <a
                  href="https://wa.me/5511995244973"
                  target="_blank"
                  className="flex items-center gap-2 justify-center lg:justify-start"
                >
                  <svg
                    viewBox="0 0 32 32"
                    className="w-10 h-10 p-1 bg-[#4dc247] rounded-full fill-white"
                  >
                    <path
                      d=" M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                  Whatsapp (11) 99524-4973
                </a>
                <a
                  href="tel:11995244973"
                  className="flex items-center gap-2 mt-3 justify-center lg:justify-start"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 28.314 28.323"
                    className="w-10 h-10 px-3 bg-primary rounded-full fill-white"
                  >
                    <path d="m27.728 20.384-4.242-4.242a1.982 1.982 0 0 0-1.413-.586h-.002c-.534 0-1.036.209-1.413.586L17.83 18.97l-8.485-8.485 2.828-2.828c.78-.78.78-2.05-.001-2.83L7.929.585A1.986 1.986 0 0 0 6.516 0h-.001C5.98 0 5.478.209 5.101.587L.858 4.83C.729 4.958-.389 6.168.142 8.827c.626 3.129 3.246 7.019 7.787 11.56 6.499 6.499 10.598 7.937 12.953 7.937 1.63 0 2.426-.689 2.604-.867l4.242-4.242c.378-.378.587-.881.586-1.416 0-.534-.208-1.037-.586-1.415zm-5.656 5.658c-.028.028-3.409 2.249-12.729-7.07C-.178 9.452 2.276 6.243 2.272 6.244L6.515 2l4.243 4.244-3.535 3.535a.999.999 0 0 0 0 1.414l9.899 9.899a.999.999 0 0 0 1.414 0l3.535-3.536 4.243 4.244-4.242 4.242z" />
                  </svg>
                  Telefone Comercial (11) 4116-9195
                </a>
                <br />
                <span className="text-red-800 uppercase">
                  Atendemos apenas Revendedores
                </span>
              </div>
              <div className="mb-4 space-x-0 md:space-x-2 md:mb-8">
                <HashLink
                  smooth
                  scroll={(el) => scrollWithOffset(el)}
                  to="/produtos#"
                  className="text-white bg-[#d2a517] hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0"
                >
                  Confira nosso catálogo
                  <svg
                    className="w-4 h-4 ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </HashLink>
              </div>
            </div>
            {/* <div
              className="flex md:justify-end w-full md:w-1/2"
              data-aos="fade-up"
              data-aos-delay="700"
            >
              <img
                alt="card img"
                className="rounded-t float-right duration-1000 w-full"
                src={heroImg}
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
